import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nav-user-profile__info" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "status"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "message" }, "Not synced", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "status tracking"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_9 = { class: "message" }
const _hoisted_10 = {
  key: 3,
  class: "status synced"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "message" }, "Synced", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

import { useStore } from '@/store'
import { formatAsDailySyncDate } from '@/utils/dailySyncDates'
import { getUserScheduleForDay } from '@/utils/dailySyncUtils'
import { DateTime } from 'luxon'
import { computed } from 'vue'
import AppAvatar from '@common/AppAvatar.vue'
import { trackingActive, trackedTask } from '@/utils/timeTrackingUtils'


export default /*#__PURE__*/_defineComponent({
  props: {
  minimized: Boolean
},
  setup(__props) {



const store = useStore()
const user = computed(() => store.getters['user/getActiveMembership'])
const userTimezone = computed(() => user.value?.userProfile?.location?.timezone)
const userSchedule = computed(() => getUserScheduleForDay(user.value?.userId, DateTime.now().toISODate()))
const userProfile = computed(() => store.getters['user/getUserProfile'])
const userHasSynced = computed(() => store.getters['dailySync/getDailySyncs'][formatAsDailySyncDate(new Date())]?.some(e => e.userId === user.value?.userId))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-user-profile", { 'nav-user-profile--minimized': __props.minimized }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/' })))
  }, [
    _createVNode(AppAvatar, {
      size: __props.minimized ? 'smaller' : 'normal',
      user: _unref(userProfile)
    }, null, 8, ["size", "user"]),
    _createElementVNode("div", _hoisted_1, [
      (!__props.minimized)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(userProfile).firstName) + " " + _toDisplayString(_unref(userProfile).lastName), 1))
        : _createCommentVNode("", true),
      (!_unref(userHasSynced))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_unref(userHasSynced) && _unref(trackingActive))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(trackedTask)), 1)
            ]))
          : (_unref(userHasSynced))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
            : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})